import { render, staticRenderFns } from "./AdminAddFaq.vue?vue&type=template&id=16e1611c&"
import script from "./AdminAddFaq.vue?vue&type=script&lang=js&"
export * from "./AdminAddFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports